import React, { Component } from 'react'
import { REACTIONS } from '../../global/obj/global'

global.isclient && require('./rxChooseTypeEmoji.css')
const rxio = global.rootRequire('classes/socket').default
const worker = global.rootRequire('classes/globalUser')
const { changeColorAva, textAva } = global.rootRequire('classes/chat')
const { rxaget, rxChangeSlug } = global.rootRequire('classes/ulti')


class RxChooseTypeEmoji extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      listUsers: [],
    }
  }

  componentDidMount() {
    rxio.socket.emit('list_reaction_message', { 
      group_id: this.props.groupId,
      message_id: this.props.messId
    }, (res) => { 
      
      const listUsers = []
      res.reactions.map((r) => r.uins.map((uId) => {
        if(r.type === this.props.typeDropEmo){
          const user = worker.users[uId]
          listUsers.push({
            id: user.id,
            avatar_url: user.profile_url,
            name: rxaget(user, 'full_name', rxaget(user, 'phone', '')),
            emojiType: REACTIONS[r.type]
          })
        }
      }
      ))
      this.setState({ listUsers })
    })
  } 

  render() { 
    return (
      <>
      {/* <div className='droped_popup_screen_bg'></div> */}
      <div className='choose_type_emoji_droped_wrap'>
        <div className='choose_type_emoji_droped_body'>
          {
            this.state.listUsers.map((user) =>
              <div key={user.id } className='droped_emoji_user border_bottom_user'>
                <div className='emoji_message_avatar'>
                  {user.avatar_url 
                    ? <img src={global.rxu.config.cdn_endpoint + user.avatar_url} 
                          className='img_avatar'
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = './images/default/static/avadefault.svg' 
                          }}/>
                    : <div className='emoji_message_avatar' style={{ background: `${changeColorAva(rxaget(user, 'id', ''))}` }}>
                        <span className='avatar-sender-user-drop'>
                        {textAva(rxChangeSlug(rxaget(user, 'name', ''), true))}
                      </span> 
                    </div>
                  }
                </div>
                <div className='droped_emoji_user_name'>
                  {user.name}
                </div>
                <div className='emoji_message_type-emoji'>
                  {user.emojiType}
                </div>
              </div>
            )
          }
        </div>
      </div>
      </>
    )
  }
}

RxChooseTypeEmoji.defaultProps = { onChange: () => { }, onClick: () => { } }

export default RxChooseTypeEmoji